'use client';

import React, { useEffect, useState } from 'react';

import { Button, Typography } from 'lighthouse';

import { StickyMobileCtaProps } from './models';

import { Shop } from 'iconsax-react';

const StickyMobileCta = ({ targetId, title, subtitle, label, startIcon, scrollThreshold = 420 }: StickyMobileCtaProps) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const targetElement = document.getElementById(targetId);
        let targetInView = false;

        const onScroll = () => {
            setVisible(window.scrollY > scrollThreshold && !targetInView);
        };

        const observer = targetElement
            ? new IntersectionObserver(
                  ([entry]) => {
                      targetInView = entry.isIntersecting;
                      onScroll();
                  },
                  { threshold: 0.15 }
              )
            : null;

        if (targetElement && observer) {
            observer.observe(targetElement);
        }

        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();

        return () => {
            observer?.disconnect();
            window.removeEventListener('scroll', onScroll);
        };
    }, [targetId, scrollThreshold]);

    return (
        <div
            className={`fixed inset-x-0 bottom-0 z-40 border-t border-primary/10 bg-white/95 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3
                shadow-elevation2 backdrop-blur-md transition-transform duration-300 xl:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`}>
            <div className='mx-auto flex max-w-lg items-center justify-between gap-3'>
                <div>
                    <Typography variant='caption' component='p' className='font-bold text-blackHighEmphasis'>
                        {title}
                    </Typography>
                    <Typography variant='overline' component='p' className='text-blackLowEmphasis'>
                        {subtitle}
                    </Typography>
                </div>
                <Button
                    component='a'
                    href={`#${targetId}`}
                    variant='contained'
                    color='primary'
                    size='medium'
                    startIcon={startIcon ?? <Shop size='18' variant='Bold' color='currentColor' />}
                    className='shrink-0 cursor-pointer text-white'>
                    {label}
                </Button>
            </div>
        </div>
    );
};

export default StickyMobileCta;
